type LinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  children: React.ReactNode;
};

export const Link: React.FC<LinkProps> = ({ href, children, ...rest }) => {
  return (
    <a href={href} className="co-underline" {...rest}>
      {children}
    </a>
  );
};
